/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs */



/**
* | output |
* | --- |
* | "Group B Text" |
*
* @param {Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_b_text_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte du groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text der Gruppe B")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo del gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст группы B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto del Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("B组文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बी पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto do Grupo B")
	return /** @type {LocalizedString} */ ("Group B Text")
});